import { memo } from "react";
import { DailyAudioTrack } from "@daily-co/daily-react";

export const AudioTile = memo(({ sessionId }: { sessionId: string }) => (
  <div>
    <DailyAudioTrack sessionId={sessionId} data-testid="daily-audio-track" />
  </div>
));
